import { useTranslation } from 'react-i18next';

export default function DisclaimerContent() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';

  if (isZh) {
    return (
      <div className="space-y-6 text-[#0A2540]/80 text-sm leading-relaxed">
        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">一、活动信息</h3>
          <p>
            全球科创圆桌联盟（Global Technology Roundtable Alliance，下称"GTRA"或"主办方"）
            在本网站发布的全部活动信息（包括议程、嘉宾、地点、时间等）力求准确，
            但可能因不可抗力或其他客观原因发生变更，主办方保留对相关信息进行调整、
            暂停或取消的权利，恕不另行通知。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">二、参与风险</h3>
          <p>
            报名参与本活动即表示参与者已充分了解并自愿承担参与过程中可能产生的
            各类风险，包括但不限于交通、住宿、饮食、健康、财物及第三方行为
            所引发的风险。主办方对上述风险所导致的人身伤害、财产损失或其他
            损害不承担任何法律责任。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">三、第三方内容</h3>
          <p>
            活动中嘉宾、演讲者、合作机构所表达的观点、提供的资料、展示的产品或服务
            均代表其个人或所属机构立场，不代表主办方意见。主办方不对第三方内容的
            准确性、完整性、合法性或时效性承担责任。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">四、投资与决策提示</h3>
          <p>
            活动中涉及的任何技术、项目、行业分析或信息均仅供参考，不构成投资建议
            或决策依据。参与者据此作出的任何投资、商业或其他决定，由其自行承担
            全部后果。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">五、知识产权</h3>
          <p>
            本网站及活动现场使用的所有商标、标识、文字、图像、音视频等内容的
            知识产权归主办方或相应权利人所有。未经书面许可，不得复制、传播、
            改编或用于商业用途。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">六、不可抗力</h3>
          <p>
            因自然灾害、公共卫生事件、政府行为等不可抗力因素导致活动无法举办或
            延期，主办方不承担违约责任，并将尽合理努力通知参与者。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">七、声明修订</h3>
          <p>
            主办方保留对本免责声明进行修订的权利。修订后的声明自在本网站发布之日起
            生效。参与者继续使用本网站或参与活动即视为接受修订后的内容。
          </p>
        </section>

        <section>
          <h3 className="text-base font-semibold text-[#0A2540] mb-2">八、联系方式</h3>
          <p>
            如对本声明有任何疑问，请通过本网站公布的官方渠道与主办方联系。
          </p>
        </section>
      </div>
    );
  }

  return (
    <div className="space-y-6 text-[#0A2540]/80 text-sm leading-relaxed">
      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">1. Event Information</h3>
        <p>
          Global Technology Roundtable Alliance ("GTRA" or the "Organizer") strives to provide
          accurate information regarding events published on this website, including agendas,
          speakers, venues, and schedules. However, such information may be subject to
          change due to force majeure or other objective circumstances. The Organizer
          reserves the right to adjust, postpone, or cancel any event-related information
          without prior notice.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">2. Participation Risk</h3>
        <p>
          By registering for and participating in an event, the participant acknowledges
          and voluntarily assumes all risks associated with participation, including but
          not limited to risks related to transportation, accommodation, food, health,
          property, and third-party conduct. The Organizer shall not be held liable for
          any personal injury, property loss, or other damages arising from such risks.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">3. Third-Party Content</h3>
        <p>
          Opinions, materials, products, or services presented by speakers, panelists, or
          partner organizations during the event represent the views of those individuals
          or their respective institutions, and do not reflect the position of the
          Organizer. The Organizer makes no representations as to the accuracy,
          completeness, legality, or timeliness of any third-party content.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">4. No Investment Advice</h3>
        <p>
          Any information regarding technologies, projects, or industry analysis discussed
          during events is provided for reference only and does not constitute investment
          advice. Any investment, business, or other decisions made based on such
          information are made at the participant's own risk.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">5. Intellectual Property</h3>
        <p>
          All trademarks, logos, text, images, audio, and video used on this website and
          at events are the intellectual property of the Organizer or the respective
          rights holders. No reproduction, distribution, adaptation, or commercial use is
          permitted without prior written consent.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">6. Force Majeure</h3>
        <p>
          The Organizer shall not be held responsible for any cancellation or postponement
          of events caused by force majeure events, including natural disasters, public
          health emergencies, or governmental actions, and will make reasonable efforts
          to notify participants of such changes.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">7. Amendments</h3>
        <p>
          The Organizer reserves the right to modify this disclaimer at any time. Revised
          versions become effective upon publication on this website. Continued use of the
          website or participation in events constitutes acceptance of the revised terms.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold text-[#0A2540] mb-2">8. Contact</h3>
        <p>
          For questions regarding this disclaimer, please contact the Organizer through
          the official channels published on this website.
        </p>
      </section>
    </div>
  );
}
